/* IZEZE — smooth open/close animation for product accordions (Mod de utilizare etc.) */
(function () {
  var DURATION_OPEN = 300;
  var DURATION_CLOSE = 240;
  var EASING = 'cubic-bezier(.4,0,.2,1)';

  function animate(el, from, to, duration, done) {
    if (!el.animate) { done && done(); return; }
    el.style.overflow = 'hidden';
    var a = el.animate(
      [{ height: from + 'px', opacity: from === 0 ? 0 : 1 },
       { height: to + 'px',   opacity: to === 0 ? 0 : 1 }],
      { duration: duration, easing: EASING }
    );
    a.onfinish = function () {
      el.style.overflow = '';
      el.style.height = '';
      el.style.opacity = '';
      done && done();
    };
  }

  function bind(details) {
    if (details.dataset.izAnim) return;
    details.dataset.izAnim = '1';
    var summary = details.querySelector('summary');
    var content = details.querySelector('.accordion__content');
    if (!summary || !content) return;

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      if (details.dataset.busy) return;
      details.dataset.busy = '1';

      if (details.open) {
        var h = content.getBoundingClientRect().height;
        animate(content, h, 0, DURATION_CLOSE, function () {
          details.open = false;
          delete details.dataset.busy;
        });
      } else {
        details.open = true;
        var end = content.getBoundingClientRect().height;
        animate(content, 0, end, DURATION_OPEN, function () {
          delete details.dataset.busy;
        });
      }
    });
  }

  function init() {
    document.querySelectorAll('.product__accordion details').forEach(bind);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
